module.exports = __webpack_public_path__ + "img/logo_dark.b98e417d.png";